import { motion } from 'framer-motion';
import styled from '@emotion/styled';

export const BackdropWrapper = styled(motion.div)<{
  backdropBackground: string;
  zIndex: number;
}>`
  position: fixed;
  z-index: ${props => props.zIndex};
  top: 0;
  left: 0;
  height: 100dvh;
  width: 100vw;
  background-color: ${props => props.backdropBackground};
`;

export const ChildrenWrapper = styled(motion.div)<{
  modalWidth: string | null;
  modalHeight: string | null;
}>`
  width: ${props => props.modalWidth ?? '100%'};
  height: ${props => props.modalHeight ?? 'auto'};
`;
